import React, { useContext } from 'react';

// import { useTranslation } from 'react-i18next';

import Permissions from '@/lib/permissions';
import AppPage from '@/ui/AppPage/AppPage';
import DataController from '@/lib/DataController';

import Umrli from '@/models/groblja/umrli';
import Ukopani from '@/models/groblja/ukopani';
import DCTable from '@/ui/Table/DCTable';
import DialogContext from '@/context/DialogContext/DialogContext';
import GeneralTableDialog from '@/ui/Dialog/GeneralTableDialog';
import GeneralGrobljaDialog from '../GeneralGrobljaDialog';
import AdvancedGrobljaDialog from '../RegistarKorisnika/AdvancedGrobljaDialog';
import { AllowRowActionFn } from '@/@types/ui/Table';
import { DCRecord } from '@/@types/lib/dataController';
import DataCentricPage from '@/ui/DataCentric/DataCentricPage';

const RegistarUmrlihPage = () => {
  // const { t } = useTranslation();

  const dc = new DataController(Umrli);
  const dcUkopani = new DataController(Ukopani)

  const { showDialog } = useContext(DialogContext);

  const handleRowAction: (action: string, id: number, record?: { [key: string]: any }) => void = (action, id) => {
    if (action === 'show_history') {
      showDialog(GeneralTableDialog, {
        mode: 'view',
        dc,
        onClose: () => {},
        level: 1,
        title: 'groblja:titles.umrli_history',
        view: 'history',
        customPath: `${Umrli.apiPath}/${id}/history`,
        tableId: 'umrli-history',
      });
    }
  };

  const handleSecondaryRowAction: (action: string, id: number, record?: { [key: string]: any }) => void = (action, id, record) => {
    if (action === 'show_history') {
      showDialog(GeneralTableDialog, {
        mode: 'view',
        dc: dcUkopani,
        onClose: () => {},
        level: 1,
        title: 'groblja:titles.ukopani_history',
        view: 'history',
        customPath: `${Umrli.apiPath}/${record?.registar_umrlih_id}/ukopani/${id}/history`,
        tableId: 'grobna-mjesta-history',
      });
    }
  };

  const allowRowAction: AllowRowActionFn = (action: string, record: DCRecord) => {
    if (action === 'show_history' && record.has_history) {
      return true;
    }
    return false;
  };

  const handleAllowAddSecondary = (records: DCRecord[]) => {
    const recordsArray = Array.isArray(records) ? records : ((records as any)?.data || []);
    const activeRecords = recordsArray.filter((record: DCRecord) => !record.is_deleted);
    return activeRecords.length === 0;
  };


  return (
    <AppPage titlett="groblja:titles.reg_umrlih" needPermission={[Permissions.GrobljaManageOsnovniRegistri]}>
      <DataCentricPage
        tableIdentifier="reg_umrlih"
        primaryModel={Umrli}
        primaryTitleToken="groblja:titles.reg_umrlih"
        primaryView="default"
        primaryDialogComponent={GeneralGrobljaDialog}
        primaryAllowEdit
        primaryAllowAdd
        primaryAllowDelete={false}
        primaryAllowExport
        secondaryModel={Ukopani}
        secondaryTitleToken="groblja:titles.reg_umrlih_ukopani"
        secondaryView="secondary"
        secondaryDialogComponent={AdvancedGrobljaDialog}
        secondaryAllowEdit
        secondaryAllowAdd
        secondaryAllowAddFunction={handleAllowAddSecondary}
        secondaryAllowDelete
        secondaryAllowColumnPicker
        baseRecordPath={Umrli.apiPath}
        // secondaryBaseRecordPath={`system/${modelComments.apiPath}/entity`}
        // primaryQueryAttribute="entity_gid"
        childRecordRelativePath="ukopani"
        foreignKeyField="registar_umrlih_id"
        additionalForeignKeyFields={['groblje_id']}
        geomRelativePath=""
        allowShowImages={false}
        allowShowSecondaryOnMap={true}
        mapId={45}
        mapModel={Umrli}
        secondaryMapFeatureAttribute="grobno_mjesto_id"
        replacePrimaryIdInSecondaryPath={true}
        allowCustomTableAction={allowRowAction}
        onCustomTableAction={handleRowAction}
        primaryAllowShowDeleted
        secondaryAllowShowDeleted
        secondaryAllowCustomTableAction={allowRowAction}
        secondaryOnCustomTableAction={handleSecondaryRowAction}
    />
    </AppPage>
  );
};

export default RegistarUmrlihPage;
